export default __webpack_public_path__ + "static/icici-5e40328da585ec58fa89faf54f874635.png";